<template>
  <div class="content">
    <h1 class="thank-you">Thank you for your purchase!</h1>
    <p class="message">We have successfully added credits to your account</p>
    <router-link to="/brand-checker" class="btn">Start Searching</router-link>
  </div>
</template>

<style>
.content {
  gap: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.thank-you,
.message {
  text-align: center;
}
</style>

<script>
export default {
  name: "ThankYou",
  mounted() {
    // set user's plan to khonsu single session:
    sessionStorage.setItem("_khonsu_user_plan_status", "active");
    sessionStorage.setItem("_khonsu_user_plan_name", "Khonsu Single Session");
  },
};
</script>
